/* eslint-disable react/no-unused-state */
import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import ReactHowler from "react-howler"
import sortBy from "lodash/sortBy"

import ControlButton from "atoms/ControlButton"
import { getStyledSecondaryColor, getStyledPrimaryColor } from "theme/palette"
import { PRIMARY_FONT } from "theme/typography"
import setlist from "utils/mocks/setlist.json"

const HeaderWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: ${({ size }) => (size === "medium" ? "101px" : "initial")};
  margin-bottom: ${({ size }) => (size === "small" ? "7px" : "0")};
  padding: ${({ size }) => (size === "large" ? "0 39px 0 50px" : "0")};
`

const titleFontSizeChooser = ({ size }) => {
  if (size === "small") {
    return "13px"
  }

  return "24px"
}

const subtitleFontSizeChooser = ({ size }) => {
  if (size === "small") {
    return "10px"
  }

  return "16px"
}

const HeaderTitle = styled.p`
  color: ${getStyledPrimaryColor()};
  font-family: ${PRIMARY_FONT};
  font-size: ${titleFontSizeChooser};
  font-weight: 700;
  margin: 0;
  text-align: center;
  ${({ wrapperSize }) => (["small", "minimal", "extraMinimal"].indexOf(wrapperSize) >= 0 ? "white-space: nowrap;" : "")}
  overflow: hidden;
  text-overflow: ellipsis;
`

const HeaderSubTitle = styled.span`
  color: ${getStyledPrimaryColor("opaque")};
  font-family: ${PRIMARY_FONT};
  font-size: ${subtitleFontSizeChooser};
  font-weight: normal;
  margin-left: ${({ size }) => (size === "small" ? "10px" : "0")};
  white-space: nowrap;
`

const HeaderComponent = ({
  currentTrack,
  theme,
  size,
  wrapperSize,
}) => (
  <HeaderWrapper size={size}>
    <HeaderTitle theme={theme} size={size} wrapperSize={wrapperSize}>
      {currentTrack && currentTrack.content.title}
      <br style={size !== "small" ? {} : { display: "none" }} />
      {Boolean(currentTrack) && Boolean(currentTrack.content.author) && (
        <HeaderSubTitle theme={theme} size={size}>{` by ${currentTrack.content.author}`}</HeaderSubTitle>
      )}
    </HeaderTitle>
  </HeaderWrapper>
)

HeaderComponent.propTypes = {
  size: PropTypes.string,
  wrapperSize: PropTypes.string,
  theme: PropTypes.string,
  currentTrack: PropTypes.shape({
    content: PropTypes.shape({
      title: PropTypes.string.isRequired,
      author: PropTypes.string,
    }).isRequired,
  }),
  onPrevClick: PropTypes.func,
  onNextClick: PropTypes.func,
}

HeaderComponent.defaultProps = {
  size: "small",
  theme: "light",
}

export default HeaderComponent



// WEBPACK FOOTER //
// ./src/components/molecules/Header/index.js